import { useAuth } from '../../Contexts/AuthContext/useAuth.context';
import { NavLink, useNavigate} from 'react-router-dom';
import './Style/Navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
//import { faChartSimple, faSquarePollVertical, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFileInvoiceDollar, faRobot, faUser } from '@fortawesome/free-solid-svg-icons';
import { DisconnectUser } from '../../Services/User/AuthenticateUser.service';

const Navbar: React.FC = () => {
    const { user } = useAuth();
    
    const navigate = useNavigate();

    const handleLogOut = async () => {
        await DisconnectUser(navigate);
    }

    return (
        <>
            <nav className="navtop">
                <section className="nav-logo">
                    <img className="app-logo" src="logo-macrolub-m.png" alt="Logo da empresa Macrolub" />
                </section>
                <section className='nav-links'>
                    {/* <NavLink  className='navlink' to='/dashboard'>
                        <div className='navlink-icon'>
                            <FontAwesomeIcon icon={faSquarePollVertical} size='2x'></FontAwesomeIcon>
                        </div>
                        <p>Dashboard</p>
                    </NavLink> */}
                    {user?.role === 'Admin' && 
                        <NavLink className='navlink' to='/users'>
                            <div className='navlink-icon'>
                                <FontAwesomeIcon icon={faUser} size='2x'></FontAwesomeIcon>
                            </div>
                            <p>Usuarios</p>
                        </NavLink>
                    }
                    {user?.role === 'Admin' && 
                        <NavLink className='navlink' to='/automations'>
                            <div className='navlink-icon'>
                                <FontAwesomeIcon icon={faRobot} size='2x'></FontAwesomeIcon>
                            </div>
                            <p>Automações</p>
                        </NavLink>
                    }
                </section>
                <section className="nav-user-dropdown">
                    {user !== null &&
                        <>
                            <h4 className="user-name">
                                {user.displayName ?? 'Fulano de tal'}
                            </h4>
                            <button type='button' onClick={handleLogOut}>
                                Logout
                            </button>
                        </>
                    }
                </section>    
            </nav>   
        </>
    )
}

export default Navbar